import './mobileCarousel.css';
import { ReactComponent as LeftInActive } from '../../assets/home/trvto_leftInActive.svg';
import { ReactComponent as RightActive } from '../../assets/home/trvto_RightActive.svg';
import { useEffect, useRef, useState } from 'react';
import FeatureCard from './FeatureCard';
import DestinationCard from './DestinationCard';
import ReviewCard from './reviewCard';
import HomeBlogCard from './HomeBlogCard';

const MobileCarouselCom = ({ type, data }) => {
    const carouselRef = useRef(null);
    const [slideWidth, setSlideWidth] = useState(0);
    const cardsPerSlide = 1;

    useEffect(() => {
        if (carouselRef.current) {
            const containerWidth = carouselRef.current.scrollWidth;
            const calculatedSlideWidth =
                containerWidth / Math.ceil(carouselRef.current.children.length / cardsPerSlide);
            setSlideWidth(calculatedSlideWidth);
        }
    }, []);

    useEffect(() => {
        if (carouselRef.current && carouselRef.current.children.length > 0) {
            const card = carouselRef.current.children[0];
            const cardWidth = card.getBoundingClientRect().width;
            setSlideWidth(cardWidth);
        }
    }, [data]);

    const scrollLeft = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({
                left: -slideWidth,
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({
                left: slideWidth,
                behavior: 'smooth'
            });
        }
    };

    const getCardByType = (type) => {
        switch (type) {
            case 'feature':
                return <FeatureCard data={data} />;
            case 'type':
                return <DestinationCard data={data} type={type} />;
            case 'destination':
                return <DestinationCard data={data} type={type} />;
            case 'review':
                return <ReviewCard data={data} />;
            case 'blog':
                return <HomeBlogCard data={data} />;
            default:
                break;
        }
    };

    return (
        <>
            <div className='destination-carousel-container' ref={carouselRef}>
                {getCardByType(type)}
            </div>
            <div className='carouselBtnWrapper'>
                <button className='carouselBtn' onClick={scrollLeft}>
                    <LeftInActive />
                </button>
                <button className='carouselBtn active' onClick={scrollRight}>
                    <RightActive />
                </button>
            </div>
        </>
    );
};

export default MobileCarouselCom;
